import { useState, useEffect } from "react";
import { Row, Col, Input, Button, message } from "antd";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { MD5 } from "@/common/Utlis";
import { findPassWordHttp } from "@/api";

const ForgetPW = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [password, setpassword] = useState("");
  const key = window.location.search.split("?identification=")[1];
  const handleOK = () => {
    if (!password) {
      message.warning(t(134));
      return false;
    }
    findPassWordHttp({
      identification: encodeURIComponent(key),
      password: MD5(password),
    }).then((res) => {
      if (res.data.code === 100) {
        message.info(res.data.msg);
        history.push("login");
      } else {
        message.warning(res.data.msg);
      }
    });
  };
  useEffect(() => {
    console.log("key：", key);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="loginBox containerBox">
      <Row className="RowBox">
        <Col className="labelTitle" span="4">
          {t(109)}
        </Col>
        <Col span="20">
          <Input.Password
            placeholder="Please input your new password"
            onChange={(e) => setpassword(e.target.value)}
            allowClear
          />
        </Col>
      </Row>
      <Row className="RowBox">
        <Button type="primary" size="large" block onClick={handleOK}>
          {t(19)}
        </Button>
      </Row>
    </div>
  );
};
export default ForgetPW;
